// src/lib/paymentAccounts.js
// Cuentas de cobro guardadas (presets) — API + formato para enviar en el chat.
import { apiFetch } from '../services/apiClient';

export async function listAccounts() {
  try { const r = await apiFetch('/api/me/payment-accounts'); return r.ok ? await r.json() : []; }
  catch { return []; }
}

export async function createAccount(data) {
  const r = await apiFetch('/api/me/payment-accounts', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data),
  });
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).message || 'No se pudo guardar');
  return r.json();
}

export async function updateAccount(id, data) {
  const r = await apiFetch(`/api/me/payment-accounts/${id}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data),
  });
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).message || 'No se pudo actualizar');
  return r.json();
}

export async function deleteAccount(id) {
  const r = await apiFetch(`/api/me/payment-accounts/${id}`, { method: 'DELETE' });
  if (!r.ok) throw new Error('No se pudo borrar');
  return true;
}

// Texto que se inserta en el chat al elegir una cuenta
export function formatAccount(a) {
  const lines = [`💳 ${a.alias} — ${a.method}`];
  if (a.holder) lines.push(`Titular: ${a.holder}`);
  lines.push(`Cuenta: ${a.number}`);
  if (a.details) lines.push(a.details);
  return lines.join('\n');
}
